import { registerQuery } from 'data-fetching-client';
import { getStripeOAuthSessionLatestStatus } from '../api/OAuthSessionApi';
export const GET_OAUTH_SESSION_LATEST_STATUS = registerQuery({
  fieldName: 'oAuthSessionLatestStatus',
  fetcher: getStripeOAuthSessionLatestStatus
});